import { defineComponent as _defineComponent } from 'vue'
import { SnowplowModuleContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { GlobalModuleName } from '@/helpers/composables/useGlobalTitles';

import Vue, { computed } from 'vue';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { ImpressionTrackingEvents } from '@/enums/events';
import { defaultObservableOptions } from '@/mixins/types/impressionTracking';
import { useArticleList } from '@/helpers/composables/useArticleList';
import PictureComp from '@/components/picture/PictureComp.vue';
import { ThumborOptions } from '@/filters/thumbor';
import AuthorBox from '@/components/editorial/AuthorBox.vue';
import { ObjectType } from '@/@types/graphql-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalEditorialLists',
  props: {
    moduleName: null
  },
  setup(__props: any) {

const props = __props as {
	moduleName: GlobalModuleName;
};



const { articles } = useArticleList({
	pageSize: 10,
	fetchAllTitles: true,
});

const articlesWithTitles = computed(() =>
	articles.value.map(article => {
		const node = article.mainObjects?.[0]?.node;

		const allTitles =
			node?.__typename === 'GenericTitleList'
				? node.allTitles?.edges?.filter(title => title.node.content.posterUrl) ?? []
				: [];

		return {
			...article,
			allTitles,
			count: node.allTitles?.totalCount ?? 0,
		};
	})
);
function imageUrl(titlePosterUrl: string | null | undefined) {
	if (!titlePosterUrl) {
		return undefined;
	}
	return Vue.filter('Thumbor')({
		url: `${JW_CONFIG.IMAGESCALER_URL}/${titlePosterUrl}`,
		imageType: 'poster',
	} as ThumborOptions);
}

function getTitle(htmlTitle?: string | null) {
	// the content is an HTML string so this slices out the <h1> tags
	if (htmlTitle == null) return '';
	return htmlTitle.replace(/<\/?[^>]+(>|$)/g, '');
}

const moduleContext = computed(() => new SnowplowModuleContext('', -1, props.moduleName, ''));

const observeVisibilityOptions = computed(() => ({
	...defaultObservableOptions,
	callback: (isVisible: boolean) => {
		if (!isVisible) return;

		TrackingHelper.trackEvent(
			ImpressionTrackingEvents.MODULE,
			{
				action: 'impression',
				nonInteraction: true,
			},
			[moduleContext.value]
		);
	},
}));

function handlePosterClick(objectId: number, objectType: ObjectType, index: number) {
	const titleContext = TrackingHelper.getTitleContextGraphql(objectId, objectType);

	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'title_clicked',
			label: 'MAIN_EDITORIAL_LISTS',
			useLastRoute: true,
			value: index,
		},
		[titleContext, moduleContext.value]
	);
}

function handleEditorialLinkClick(fullPath: string) {
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'content_clicked',
			label: fullPath,
			useLastRoute: true,
			property: 'editorial_pick',
		},
		[moduleContext.value]
	);
}

return { __sfc: true,props, articles, articlesWithTitles, imageUrl, getTitle, moduleContext, observeVisibilityOptions, handlePosterClick, handleEditorialLinkClick, HiddenHorizontalScrollbar, PictureComp, AuthorBox }
}

})